<template>


    <div class="flex gap-3">
        <a id="instagram" href="https://www.instagram.com/" target="_blank" class="social ">

            <font-awesome-icon class="text-white hover:text-secondaryDark  dark:text-secondaryDark "
                icon="fa-brands fa-instagram" />
        </a>
        <a id="tiktok" href="https://www.tiktok.com/" target="_blank"
            class="social   ">

            <font-awesome-icon class="text-white hover:text-secondaryDark dark:text-secondaryDark"
                icon="fa-brands fa-tiktok" />

        </a>
        <a id="snapchat" href="https://www.snapchat.com/" target="_blank"
            class="social ">
            <font-awesome-icon class="text-white hover:text-secondaryDark dark:text-secondaryDark"
                icon="fa-brands fa-snapchat" />

        </a>
        <a id="linkedin" href="https://www.linkedin.com/" class="social  " target="_blank">
            <font-awesome-icon class="text-white hover:text-secondaryDark dark:text-secondaryDark"
                icon="fa-brands fa-linkedin-in" />

        </a>

        <a id="x" href="https://x.com/" target="_blank"  class="social   ">

            <font-awesome-icon class="text-white hover:text-secondaryDark dark:text-secondaryDark"
                icon="fa-brands fa-x-twitter" />
        </a>
    </div>




</template>




<style scoped>
    .social {
        display: flex;

        justify-content: center;
        align-items: center;

        width: 2.50rem;
        height: 2.50rem;
        border-radius: 50%;
        background-color: #374151;

    }

    .social:hover {
        background-color: #dcdbe2;
        color: #000;
        border: 1px solid #000;
    }
</style>
